import {
  Component,
  Input,
  OnInit,
  OnDestroy,
  NgZone,
  EventEmitter,
  ViewChild,
} from "@angular/core";
import { ModalDirective } from "ngx-bootstrap/modal";
import { Subscription } from "rxjs";
import {
  ToastrService,
  Company,
  Minesite,
  CompanyService,
  MinesiteService,
  CompanyMinesites,
  CompanyEquipment,
  CompanyUsers,
  Equipment,
  User,
  DataArray,
  ProjectService,
  Project,
} from "./../../../../shared/index";

@Component({
  selector: "company-list",
  templateUrl: "./company-list.html",
  standalone: false,
})
export class CompanyListComponent implements OnInit, OnDestroy {
  @ViewChild("companyModal") companyModal: ModalDirective;
  @ViewChild("createCompanyModal") createCompanyModal: ModalDirective;
  @Input()
  color = "panel-success";
  @Input("live") live = true;
  @Input("Is_Project_Selected") Is_Project_Selected = false;
  public add = true;
  public company: Company = new Company();
  public equipment: DataArray<Equipment> = new DataArray<Equipment>(1);
  public allUsers: User[] = [];
  public availableUsers: User[] = [];
  private selectedUsers: User[] = [];
  public companyUsers: User[] = [];
  public companies: Company[] = [];
  public minesites: Minesite[] = [];
  filename: string;
  private files: File[];
  private subscriptions: Subscription[] = [];
  private shouldUpload = false;
  public displayWarning = false;

  private userIds: number[] = [];

  public selected: number[] = [];
  public associatedSelected: number[] = [];
  public project: Project[] = [];
  public processing = true;

  constructor(
    private _ngZone: NgZone,
    private _companyService: CompanyService,
    private _minesiteService: MinesiteService,
    private _toastrService: ToastrService,
    private _ProjectService: ProjectService
  ) {
    //this._ProjectService.Get_All_Projects();
  }

  ngOnInit(): void {
    this.subscriptions.push(
      this._companyService.companysChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          if (info.companies.length > 0) {
            if (this.live) {
                if (info.companies.length > 0) {
                    const newCompanies = info.companies.filter(
                        (incoming: Company) => !this.companies.some(existing => existing.Id === incoming.Id)
                    );
                    this.companies = [...this.companies, ...newCompanies];
                }
                //TODO: add handling: also receives info.isFinalPage
                for (let i = 0; i < info.length; i++) {
                this.companies[i].Status = 0;
                }
            } else {
                if (info.companies.length > 0) {
                    const newCompanies = info.companies.filter(
                        (incoming: Company) => !this.companies.some(existing => existing.Id === incoming.Id)
                    );
                    this.companies = [...this.companies, ...newCompanies];
                }
              //TODO: add handling: also receives info.isFinalPage

              //for (var i = 0; i < info.length; i++) {
              //    this.companies[i].Is_Published = this.companies[i].Is_Live;
              //}
            }
            this.processing = false;
          }
        });
      })
    );
    this.subscriptions.push(
      this._ProjectService.allProjectChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.project = info;
        });
      })
    );

    this.subscriptions.push(
      this._companyService.allUsersChange.subscribe((info: any) => {
        this._ngZone.run(() => {
          this.allUsers = [];
          this.allUsers = info;
        });
      })
    );

    this.subscriptions.push(
      this._companyService.companyChange.subscribe((company: Company) => {
        this._ngZone.run(() => {
          if (this.company.Name == company.Name) {
            this.company = new Company();
          }
          this.companies = this._companyService.companies.Data;
        });
      })
    );

    this.subscriptions.push(
      this._companyService.showDetailsChange.subscribe((company: Company) => {
        this._ngZone.run(() => {
          this.company = company;
          this.equipment.init();
          this._companyService.getAllUsers();
          if (this.live)
            this._minesiteService.getMinesitesForCompany(this.company.Id);
          else
            this._minesiteService.getMinesitesForCompanyStaging(
              this.company.Id
            );

          this.companyModal.show();
        });
      })
    );

    this.subscriptions.push(
      this._companyService.companyEquipmentChange.subscribe(
        (companyEquipment: CompanyEquipment) => {
          if (this.company.Id == companyEquipment.CompanyId) {
            this._ngZone.run(() => {
              for (const equipment of companyEquipment.Equipment) {
                this.equipment.update(equipment, true);
              }
            });
          }
        }
      )
    );

    this.subscriptions.push(
      this._minesiteService.companyMinesiteChanges.subscribe(
        (companyMinesites: CompanyMinesites) => {
          if (this.company.Id == companyMinesites.CompanyId) {
            this._ngZone.run(() => {
              //this.minesites = companyMinesites.Minesites;
              this.minesites = companyMinesites.Minesites.map((minesiteRaw) => {
                const site = new Minesite();
                Object.assign(site, minesiteRaw);

                // Re-hydrate the Equipment array
                site.Equipment = new DataArray<Equipment>(1);
                site.Equipment.init();
                const mineSiteArray = Array.isArray(minesiteRaw.Equipment)
                  ? minesiteRaw.Equipment
                  : minesiteRaw.Equipment.Data;
                for (const e of mineSiteArray || []) {
                  const equipment = new Equipment();
                  Object.assign(equipment, e);
                  site.Equipment.update(equipment, true);
                }

                // Same for Companies, if needed
                site.Companies = new DataArray<Company>(1);
                site.Companies.init();
                const companyArray = Array.isArray(minesiteRaw.Companies)
                  ? minesiteRaw.Companies
                  : minesiteRaw.Companies.Data;
                for (const c of companyArray || []) {
                  const company = new Company();
                  Object.assign(company, c);
                  site.Companies.update(company, true);
                }

                return site;
              });
            });
          }
        }
      )
    );

    this.subscriptions.push(
      this._companyService.companyUsersChange.subscribe(
        (companyUsers: CompanyUsers) => {
          if (this.company.Id == companyUsers.CompanyId) {
            this._ngZone.run(() => {
              this.companyUsers = companyUsers.Users;
              // reset the available user list
              this.availableUsers = [];
              this.availableUsers = this.allUsers;
              // remove the company users from the allUsers list
              const idx = 0;
              for (let i = 0; i < this.companyUsers.length; i++) {
                const x = 0;
                for (let x = 0; x < this.availableUsers.length; x++) {
                  if (this.availableUsers[x].Id == this.companyUsers[i].Id) {
                    this.availableUsers.splice(x, 1);
                    break;
                  }
                }
              }

              this.availableUsers.sort((a, b) =>
                a.FirstName + a.LastName < b.FirstName + b.LastName
                  ? -1
                  : a.FirstName + a.LastName > b.FirstName + b.LastName
                  ? 1
                  : 0
              );
            });
          }
        }
      )
    );

    this.subscriptions.push(
      this._companyService.showEditChange.subscribe((company: Company) => {
        this.company = company;
        this.add = false;
        this.createCompanyModal.show();
      })
    );
    this._companyService.getCompaniesConstraint(this.live);
    this._companyService.getAllUsers();
  }

  ngOnDestroy(): void {
    for (const subscription of this.subscriptions) {
      subscription.unsubscribe();
    }
  }

  public close(): void {
    this.companyModal.hide();
  }

  public addCompany(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }
    this.add = true;
    this.company = new Company();
    this.createCompanyModal.show();
  }

  public preUpload(event: any): void {
    this.files = event.srcElement.files;
    this.filename = this.files[0].name;
    this.shouldUpload = true;
  }

  public cancelAdd(): void {
    this.createCompanyModal.hide();
    //this._companyService.getCompany(this.company.Id,this.live);
    //this.company = new Company();
  }

  public create(another: boolean = false): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }

    if (this.add) {
      this._companyService.create(this.company, this.live);
      if (!another) {
        this.createCompanyModal.hide();
      }
      return;
    }

    this._companyService.update(this.company);
    this.createCompanyModal.hide();
    if (this.shouldUpload) {
      const formData: FormData = new FormData(),
        xhr: XMLHttpRequest = new XMLHttpRequest();
      formData.append("companyId", this.company.Id.toString());

      for (let i = 0; i < this.files.length; i++) {
        formData.append("uploads[]", this.files[i], this.files[i].name);
      }
      formData.append("userId", localStorage.getItem("User_ID"));
      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200) {
            this._toastrService.displayToastrMessage(
              "success",
              "Company logo uploaded for " + this.company.Name + "!",
              "Logo Upload"
            );
          } else {
            this._toastrService.displayToastrMessage(
              "error",
              "Company logo upload failed for " + this.company.Name + "!",
              "Logo Upload"
            );
          }
          this.shouldUpload = false;
          this.filename = "";
          this.files = [];
        }
      };

      xhr.open(
        "POST",
        window.document.location.origin + "/api/Manuals/UploadCompanyLogo",
        true
      );
      xhr.send(formData);
    }
  }

  public selectUser(user: User): void {
    this.displayWarning = false;
    user.Selected = !user.Selected;
  }

  public selectAllAvailableUsers(): void {
    this.displayWarning = false;
    for (const user of this.availableUsers) {
      user.Selected = true;
    }
  }

  public selectAllCompanyUsers(): void {
    this.displayWarning = false;
    for (const user of this.companyUsers) {
      user.Selected = true;
    }
  }

  public addCompanyUsers(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }

    this.selectedUsers = [];
    this.selectedUsers = this.availableUsers.filter((u) => u.Selected === true);

    if (this.selectedUsers.length == 0) {
      this.displayWarning = true;
      return;
    }

    let idx = 0;
    for (let i = 0; i < this.selectedUsers.length; i++) {
      // add the selected users onto the company user array
      this.selectedUsers[i].Selected = false;
      this.companyUsers.push(this.selectedUsers[i]);

      // remove the select user from the available users array
      idx = this.availableUsers.indexOf(this.selectedUsers[i]);
      this.availableUsers.splice(idx, 1);
    }

    this.companyUsers.sort((a, b) =>
      a.FirstName + a.LastName < b.FirstName + b.LastName
        ? -1
        : a.FirstName + a.LastName > b.FirstName + b.LastName
        ? 1
        : 0
    );

    // convert the companyUser array into an array of just ids
    this.userIds = [];
    for (let u = 0; u < this.companyUsers.length; u++) {
      this.userIds.push(this.companyUsers[u].Id);
    }
    this._companyService.updateCompanyUsers(this.company.Id, this.userIds);
  }

  public removeCompanyUsers(): void {
    if (Number(localStorage.getItem("Lock")) == 1) {
      this._toastrService.displayToastrMessage(
        "error",
        localStorage.getItem("Msg"),
        "Environment Status!"
      );
      return;
    }

    this.selectedUsers = [];
    this.selectedUsers = this.companyUsers.filter((u) => u.Selected === true);

    if (this.selectedUsers.length == 0) {
      this.displayWarning = true;
      return;
    }

    let idx = 0;
    for (let i = 0; i < this.selectedUsers.length; i++) {
      // add the selected user onto the available user array
      this.selectedUsers[i].Selected = false;
      this.availableUsers.push(this.selectedUsers[i]);

      // remove the selected users from the company user array
      idx = this.companyUsers.indexOf(this.selectedUsers[i]);
      this.companyUsers.splice(idx, 1);
    }

    this.availableUsers.sort((a, b) =>
      a.FirstName + a.LastName < b.FirstName + b.LastName
        ? -1
        : a.FirstName + a.LastName > b.FirstName + b.LastName
        ? 1
        : 0
    );

    // convert the companyUser array into an array of just ids
    this.userIds = [];
    for (let u = 0; u < this.companyUsers.length; u++) {
      this.userIds.push(this.companyUsers[u].Id);
    }

    this._companyService.updateCompanyUsers(this.company.Id, this.userIds);
  }

  //public userList(assigned: boolean): User[] {
  //    if (assigned) {
  //        return this.allUsers.filter((c) => {
  //            return this.isUserAssigned(c.Id);
  //        });
  //    } else {
  //        return this.allUsers.filter((c) => {
  //            return !this.isUserAssigned(c.Id);
  //        });
  //    }
  //}

  //public isUserAssigned(userId: number): boolean {
  //    if (this.companyUsers.length === 0) {
  //        return true;
  //    }
  //    else {
  //        if (this.companyUsers.find((value) => { return value.Id == userId })) {
  //            return true;
  //        }
  //    }
  //    return false;
  //}
}
